import { Link } from 'react-router-dom';
import { RadioGroup, FormControl, Grid, MenuItem, Radio, Stack, TextField, Typography, IconButton, InputAdornment } from '@mui/material';
import { CustomButton, CustomInputLabel, CustomRadio, CustomSelect, FlexDiv, SectionDivider, SelectInputProps, StyledCard, StyledCardTitle, CustomTextField } from 'custom/components';
import React from 'react';
import styles from 'custom/style.module.css';
import docStyles from './docstack.module.css';
import docStreamStyles from '../docsStream/docs.module.css';
import { DeleteIcon, EditIcon, CancelIcon } from '../../../custom/constants';
import { CheckCircleOutline, Replay, Save } from '@mui/icons-material';
import DocViewer from '../docsStream/DocViewer';
import { dateTolocale } from 'utils/converter';
// import { Document, Page } from 'react-pdf';

const DocStack = (props) => {
  const { docData, editedName, setEditedName, setEditingDocId, editingDocId, changeTargetDoc, targetDocId, confirmFiling, docId, mainDocData, undoStack, handleUndo, newFileName, setNewFileName } = props;


  const docs = props.docs.map((doc, i) => {
    let name = doc.name || 'Unknown';
    if (doc.type == 'AWB') {
      if (doc.awb)
        name = `${doc?.awb?.code}-${doc?.awb?.number}`;
      else
        name = doc.data?.awb_no ? doc.data?.awb_no : name;
    }
    if (doc.request && (!doc.request_status || !name)) {
      if (doc.type == 'AWB') {
        name = 'Airway Bill';
      } else if (doc.type == 'FFM') {
        name = 'Flight Manifest';
      } else if (doc.type == 'OTHER') {
        name = 'Other Document';
      }
    }

    const getSatusColor = (doc, verified, received, requested) => {
      if (doc.verified && doc.request_status) {
        return verified;
      } else if (doc.request_status) {
        return received;
      } else {
        return requested;
      }
    };

    return (
      <Grid container key={i} justifyContent='space-between' spacing={0} className={`${docStyles.px4} ${styles.colorPrimary}`}>
        <RadioGroup aria-labelledby='documents' name='user-status' defaultValue='all' row className={`${styles.fSpaceBtw} ${styles.w100}`} onChange={() => props.selectDoc(doc)} value={props.docId} >
          <Grid item container>
            <Grid item sx={{ width: '30px' }}>
              <CustomRadio control={<Radio size='small' inputProps={{ 'aria-label': 'documents' }} />} value={doc.id} label='' />
            </Grid>
            <Grid item xs container spacing={2}>
              <Grid item xs={12} sm={6}>
                {editingDocId === doc.id ? (
                  <TextField
                    size='small'
                    variant='standard'
                    value={editedName}
                    onChange={(e) => setEditedName(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        props.handleEditName(doc.id, editedName);
                        setEditingDocId(null);
                      } else if (e.key === 'Escape') {
                        setEditingDocId(null);
                      }
                    }}
                    autoFocus
                  />
                ) : (
                  <Typography
                    variant='subtitle2'
                    component='div'
                    fontWeight={900}
                    flexWrap='nowrap'
                    onDoubleClick={() => {
                      setEditingDocId(doc.id);
                      setEditedName(name);
                    }}
                    className={styles.pointer}
                  >
                    {name}
                  </Typography>
                )}
                {/* {!doc.verified && doc.request && doc.request_status && <Typography variant='caption' color='text.error' fontWeight={'700'} lineHeight='normal'> Recivied </Typography>}
                  {!doc.verified && doc.request && !doc.request_status && <Typography variant='caption' color='red' fontWeight={'700'} lineHeight='normal'> Pending </Typography>}
                  {(!doc.request || doc.verified) && <Typography variant='caption' color='text.secondary' lineHeight='normal'> {dateTolocale(doc.created, 'DD MMM YY HH:mm')} </Typography> } */}
                <Typography variant='caption' color='text.secondary' lineHeight='normal'> {dateTolocale(doc.created, 'DD MMM YY HH:mm')} </Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Stack direction={'column'} height={'100%'}>
                  <Typography variant='subtitle2' component='div' fontWeight={900}>
                    {doc.awb ? `${doc.awb.pcs}` : <span className={styles.vHidden}>-</span>}
                    {doc.type == 'HAWB' && doc?.data?.pcs ? `${doc.data.pcs}` : ''}
                  </Typography>
                  <Typography variant='caption' color='text.secondary' lineHeight='normal' flexGrow={1} alignItems={'flex-end'} display={'flex'}>
                    {doc.numPages} Pages
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography variant='subtitle2' component='div' fontWeight={900}>
                  {doc.awb ? `${doc.awb.wgt}K` : <span className={styles.vHidden}>-</span>}
                  {doc.type == 'HAWB' && doc?.data?.wgt ? `${doc.data.wgt}K` : ''}
                </Typography>
              </Grid>
            </Grid>
            <Grid item sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}>
              {!doc.verified && (!doc.request || !doc.request_status) && (
                <>
                  {editingDocId === doc.id ? (
                    <>
                      <IconButton
                        className={docStreamStyles.saveIcon}
                        color='success'
                        size='small'
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          props.handleEditName(doc.id, editedName);
                          setEditingDocId(null);
                        }}
                        aria-label='save'
                      >
                        <CheckCircleOutline />
                      </IconButton>
                      <CancelIcon
                        className={docStreamStyles.cancelIcon}
                        color='error'
                        onClick={() => setEditingDocId(null)}
                      />
                    </>
                  ) : (
                    <Stack direction='row' spacing={1}>
                      <EditIcon
                        className={docStreamStyles.editIcon}
                        onClick={() => {
                          setEditingDocId(doc.id);
                          setEditedName(name);
                        }}
                      />
                      <DeleteIcon
                        className={docStreamStyles.delIcon}
                        onClick={(e) => props.handleDelete(doc.id, e.currentTarget)}
                      />
                    </Stack>
                  )}
                </>
              )}

              {/* {doc.verified && <CheckCircleOutline color='success' />} */}
            </Grid>

            {doc.source && <Grid item xs={12}>
              <Typography variant='caption' color='text.secondary' display='flex' pt={0.25} sx={{ paddingLeft: '30px' }}>
                From: {doc.source}
              </Typography>
            </Grid>}
            {doc.awb ? <Grid item xs={12}>
              <Typography variant='caption' color='text.secondary' display='flex' pt={0.25} sx={{ paddingLeft: '30px' }}>
                {doc.awb.forwarder}
              </Typography>
            </Grid>
              : <span ></span>}
            {doc.request &&
              <Grid item xs={12}>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}
                  p={'2px 24px 2px 54px'}
                  m={'8px -24px -16px -24px'}
                  bgcolor={getSatusColor(doc, '#2e7d3214', '#ff7e0d14', '#ff000014')}
                  zIndex={1}
                  position={'relative'}
                  onClick={() => props.handleOpen('thirdPartyDoc', doc)}
                  className={styles.pointer}
                >
                  <Typography variant='caption' component='div' flexWrap={'nowrap'} color={'#000000bf'}>Request for doc from 3rd party</Typography>
                  <small style={{
                    color: '#515151',
                    fontSize: '10px',
                    fontWeight: 700,
                    display: 'block',
                    marginLeft: 'auto',
                  }}>STATUS :&nbsp;</small>
                  <Typography variant='caption' component={'small'} fontWeight={700}
                    color={getSatusColor(doc, '#2e7d32', '#ff7e0d', 'error')}>
                    {/* {getSatusColor(doc, 'Doc Verified', 'Doc Received', 'Request Sent')} */}
                    {getSatusColor(doc, 'Verified', 'Received', 'Requested')}
                  </Typography>
                </Stack>
              </Grid>
            }
            <Grid item xs={12}>
              <SectionDivider className={styles.my3} />
            </Grid>
          </Grid>
        </RadioGroup>
      </Grid>
    );

  });

  // Exclude current doc from target doc select options
  const docOptions = props.docs
    .filter(doc => doc.id !== props.docId)
    .map((doc, i) => {
      let name = doc.name || 'Unknown';
      if (doc.type == 'AWB') {
        if (doc.awb)
          name = `${doc?.awb?.code}-${doc?.awb?.number}`;
        else
          name = doc.data?.awb_no ? doc.data?.awb_no : name;
      }
      return (
        <MenuItem key={i} value={doc.id} id={doc.id}>{name}</MenuItem>
      );
    });
  return (
    <div>
      <Grid container spacing={3}>
        <Grid item className={`${docStreamStyles.docSec} ${docStreamStyles.docSecList} `} order={1}>
          <StyledCard className={`${docStreamStyles.incomingDocH100} ${styles.fColumn}`}>
            <div className={docStreamStyles.incomingDocHead}>
              <FlexDiv>
                <StyledCardTitle>AWB Document Stack {mainDocData ? `- ${mainDocData?.name}` : ''}</StyledCardTitle>
              </FlexDiv>
              <Typography variant='caption' color='text.secondary' fontWeight={500}>{props.docs.length} Documents</Typography>
            </div>
            <SectionDivider className={styles.my3} />
            <div className={`${docStreamStyles.listDocBody} ${docStyles.awbList}`}>
              {docs}
            </div>
            <Stack mt={'auto'} direction='row'>
              <CustomButton variant='contained' className={docStyles.btn} component={Link}
                to={'/docs_stream'}>Back</CustomButton>
            </Stack>
          </StyledCard>
        </Grid>
        <Grid item xs className={`${docStreamStyles.docView}`} order={{
          xs: 2,
          sm: 3,
          md: 3,
          lg: 2,
        }}>
          <DocViewer
            docData={docData}
            currentPage={props.currentPage}
            handlePageChange={props.handlePageChange}
          />
        </Grid>
        <Grid item className={`${docStreamStyles.docSec} ${docStreamStyles.docSecVerify}`} order={{
          xs: 3,
          sm: 2,
          md: 2,
          lg: 3,
        }}>
          <StyledCard className={`${styles.h100} ${styles.fColumn}`}>
            <div className={docStreamStyles.incomingDocHead}>
              <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <div>
                  <FlexDiv><StyledCardTitle>Re-File Document</StyledCardTitle></FlexDiv>
                  <Typography variant='caption' color='text.secondary' fontWeight={500}>Select required document</Typography>
                </div>
                {(undoStack && undoStack.length > 0) ? (
                  <Stack direction='column' alignItems='center' mt={'-6px'}>
                    <IconButton aria-label='undo last filing' className={docStyles.undoIcon} color='primary' size='small' onClick={() => handleUndo()}>
                      <Replay />
                    </IconButton>
                    <span className={docStyles.undoIconText}>Undo</span>
                  </Stack>
                ) : null}
              </Stack>
              <SectionDivider className={styles.my3} />
              <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
                <CustomInputLabel id='re-file-awb-label' aria-label='Select-re-file-awb' required>Re-File with AWB</CustomInputLabel>
                <div className={docStyles.addTextField}>
                  <FormControl variant='standard' fullWidth>
                    <CustomSelect
                      {...SelectInputProps}
                      id='airline'
                      labelId='re-file-awb-label'
                      fullWidth
                      onChange={(doc) => changeTargetDoc(doc.target.value)}
                      // name='airline'
                      value={targetDocId || ''}
                    // classes={{ select: !props.flightFields.airline ? styles.colorPlaceholder : '' }}
                    >
                      {docOptions}
                    </CustomSelect>
                  </FormControl>
                </div>
                {(targetDocId && docId) ? (
                  <CustomButton variant='contained' onClick={() => confirmFiling('split')} className={`${docStyles.btn} ${styles.mlauto} ${styles.mt3}`}>Confirm</CustomButton>
                ) : null}
              </Stack>
              <Stack direction='row' alignItems='center' spacing={2} mt={3}>
                <FormControl variant='standard' fullWidth className={docStyles.textFieldWrapper}>
                  <CustomInputLabel id='save-as-new-label' aria-label='Save-as-new' className={docStyles.ipLabel}>
                    Save Page As
                  </CustomInputLabel>
                  <CustomTextField
                    type='text'
                    value={newFileName}
                    onChange={(e) => setNewFileName(e.target.value)}
                    placeholder='Enter new file name'
                    className={`${docStyles.inputField} ${docStyles.addTextField}`} 
                    label=''
                    InputProps={{
                      classes: {
                        root: docStyles.inputFieldRoot,
                        input: docStyles.inputFieldIp
                      },
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton aria-label='save new file name'
                            disabled={!newFileName.trim() || !docId}
                            onClick={() => confirmFiling('new')}
                            color='primary'
                            classes={{
                              root: docStyles.inputAdornmentBtn,
                              disabled: docStyles.inputAdornmentBtnDisabled
                            }}
                            size='small'
                          >
                            <Save color='inherit' fontSize='inherit' />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </FormControl>
              </Stack>
            </div>
            <Stack mt={'auto'} direction='row' justifyContent='flex-end'>
              <CustomButton variant='contained' onClick={props.handleProcessStack} className={`${docStyles.btn} ${styles.mlauto}`}>File Stack</CustomButton>
            </Stack>

          </StyledCard>
        </Grid>
      </Grid>
    </div>
  );
};

export default DocStack;